export default __webpack_public_path__ + "static/media/logo-white-1.7372f9ef.png";